import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/do";

export class AuthRedirectInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
    return next.handle(request).do(
      (event: HttpEvent<any>) => {},
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            document.location.href = "#/login";
          }
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/http-interceptors/auth-redirect-interceptor.ts